import React from "react";
import Sidebar from "../../components/CustomerPortal/SideBar";
import Header from "../../components/Header";
import Footer from "../../components/CustomerPortal/Footer";
import {
  DocumentTextIcon,
  DocumentPlusIcon,
  DocumentCheckIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/solid";
import { useState, useEffect } from "react";
import { API_ROUTES } from "../../utils/constants";
import axios from "axios";
import { NumericFormat } from "react-number-format";
import { getTokenFromLocalStorage } from "../../lib/common";
import { Bars } from "react-loader-spinner";

const Dashboard = () => {
  const [primary, setPrimary] = React.useState([]);
 
 
  const [column, setColumn] = React.useState([]);
 
 
  useEffect(() => {
 
 
   getData();
}, []);
  
 

  const getData = async () => {
    let config = {
      Authorization: getTokenFromLocalStorage(),
    };

    
    const { data } = await axios({
      method: "get",
      url: API_ROUTES.ACCOUNT_SUMMERY,
      headers: config,
    });
    console.log(data?.data[0]);
    setPrimary(data?.data[0]);
    let summary  = await axios({
      method: "get",
      url: API_ROUTES.PRIMARY_ACCOUNT,
      headers: config,
    });

    console.log("ddddd");
    console.log(summary.data.data[0]);

     setColumn(summary.data.data[0]);
  };

 if (primary?.length == 0) {
   return (
     <div class="flex justify-center items-center">
       <Bars
         height="100vh"
         width="80"
         color="#4d148c"
         ariaLabel="bars-loading"
         wrapperStyle={{}}
         wrapperClass=""
         visible={primary.length == 0}
       />{" "}
     </div>
   );
 }

//   const column = [
//     {
//       name: "Currency",
//       selector: (row) => row.Currency,
//     },
//     {
//       name: "0-9 days",
//       selector: (row) => row["0-9 days"]
//     },
//   ];

//   useEffect(()=> {
//     const fetData = async () => {
//       axios
//         .get(API_ROUTES.PRIMARY_ACCOUNT)
//         .then((res) => setSummery(res.data))
//         .catch((err) => console.log(err));
//     };

//     fetData();
//   }, []);

 
 
 // const [summery, setSummery] = useState([]);
 
 
 
  return (
    <div>
      <div className="pb-5">
        <Header name={{ name: "Welcome to React" }} />
      </div>
      <Sidebar />
      <div class="p-4 sm:ml-64">
        
        <div class="p-4       rounded-lg  ">
          <div class="grid grid-cols-3 gap-4 mb-4">
            
            <div class="items-right   rounded bg-gray-50 dark:bg-gray-800">
              
              <p className="flex text-gray-500 mt-4">
                Primary Account :{primary["Primary Account"]}
              </p>
              <p className="text-gray-500 mt-4">
                Original Charges :
                <NumericFormat
                  value={primary["Original Charges"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
              </p>
              <p className="text-gray-500 mt-4">
                Past Due :
                <NumericFormat
                  value={primary["Past Due"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
              </p>
              <p className="text-gray-500 mt-4">
                In Dispute :
                <NumericFormat
                  value={primary["In dispute"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
              </p>
              <p className="text-gray-500 mt-4">
                Payments & Adjustments :
                <NumericFormat
                  value={primary["Payments & Adjustments"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
              </p>
              <p className="text-gray-500 mt-4">
                Current Account Balance :
                <NumericFormat
                  value={primary["Current Account Balance"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
              </p>
            </div>
{/* 
            <div class=" max-w-sm p-6 bg-whit   rounded-lg shadow dark:bg-gray-800   items-center justify-center  hover:bg-slate-200 flex flex-col ">
              <a href="/open-invoice">
                <DocumentTextIcon className="h-40 w-40  text-purple" />
                <h5 class="mb-2 text-1xl font-bold text-purple    items-center text-center">
                  OPEN INVOICES
                </h5>
              </a>
            </div>

            <div class=" max-w-sm p-6 bg-whit   rounded-lg shadow dark:bg-gray-800   items-center justify-center  hover:bg-slate-200 flex flex-col ">
              <a href="/past-due-invoices">
                <DocumentPlusIcon className="h-40 w-40  text-purple" />
                <h5 class="mb-2 text-1xl font-bold text-purple    items-center text-center">
                  PAST DUE
                </h5>
              </a>
            </div> */}
          </div>

          {/* <div class="flex grid grid-cols-3 gap-4 mb-4">
            <div class=" max-w-sm p-6 bg-whit   rounded-lg shadow dark:bg-gray-800   items-center justify-center  hover:bg-slate-200 flex flex-col ">
              <a href="/Paid-closed-invoices">
                <DocumentCheckIcon className="h-40 w-40  text-purple" />
                <h5 class="mb-2 text-1xl font-bold text-purple    items-center text-center">
                  PAID CLOSE
                </h5>
              </a>
            </div>

            <div class=" max-w-sm p-6 bg-whit   rounded-lg shadow dark:bg-gray-800   items-center justify-center hover:bg-slate-200  flex flex-col ">
              <a href="/in-dispute-invoices">
                <ExclamationCircleIcon className="h-40 w-40  text-purple" />
                <h5 class="mb-2 text-1xl font-bold text-purple    items-center text-center">
                  IN DISPUTE
                </h5>
              </a>
            </div>
          </div> */}

 
          <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
            <h2 className="text-2xl pt-4 pl-4 md:pl-12 md:pr-8 pb-6">
              Primary Account
            </h2>
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                <tr>
                  <th className="border-b px-4 py-2 font-normal">Currency</th>
                  <th className="border-b px-4 py-2 font-normal">0-9 days</th>
                  <th className="border-b px-4 py-2 font-normal">9-15 days</th>
                  <th className="border-b px-4 py-2 font-normal">16-30 days</th>
                  <th className="border-b px-4 py-2 font-normal">31-60 days</th>
                  <th className="border-b px-4 py-2 font-normal">61-90 days</th>
                  <th className="border-b px-4 py-2 font-normal">91+ days</th>
                  <th className="border-b px-4 py-2 font-normal">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-2">{column["Currency"]}</td>
                  <td className="px-4 py-2">
                    
                  <NumericFormat
                  value={column["0-9 days"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
                    </td>
                  <td className="px-4 py-2">
                  <NumericFormat
                  value={column["10-15 days"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
                  </td>
                  <td className="px-4 py-2">
                  <NumericFormat
                  value={column["16-30 days"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
                </td>
                  <td className="px-4 py-2">
                  <NumericFormat
                  value={column["31-60 days"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                /> 
                    </td>
                  <td className="px-4 py-2">
                  <NumericFormat
                  value={column["61-90 days"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
                  </td>
                  <td className="px-4 py-2">
                  <NumericFormat
                  value={column["91+ days"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
                    </td>
                  <td className="px-4 py-2">
                  <NumericFormat
                  value={column["Total"]}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={""}
                />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
 
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Dashboard;

